import { GraphQLNonNull, GraphQLList, GraphQLID } from 'graphql'
import { Context } from '../shared'
import { ContrastGraphQLFieldConfig } from '..'
import { SensitiveDataPolicy } from '../../../components/sensitive-data'
import { sensitiveDataPolicySummaryType } from '../types/sensitive-data-types'

const normalize = ({
  id,
  group_id: groupID,
  name,
  is_required: required,
  is_enabled: enabled,
  keywords
}) => ({
  id,
  groupID,
  name,
  required,
  enabled,
  keywords
})

interface SensitiveDataPoliciesQueryArgs {
  readonly organizationID: string
}

const sensitiveDataPoliciesQueryArgs = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  }
}

export const sensitiveDataPolicySummaries: ContrastGraphQLFieldConfig<
  any,
  Context,
  SensitiveDataPoliciesQueryArgs,
  SensitiveDataPolicy[]
> = {
  description: 'Get sensitive data policies by organization ID',
  type: new GraphQLNonNull(
    new GraphQLList(new GraphQLNonNull(sensitiveDataPolicySummaryType))
  ),
  args: sensitiveDataPoliciesQueryArgs,
  async resolve(_source, args, context) {
    const { organizationID } = args
    const { connector } = context
    const { policies } = await connector.get(
      `/${organizationID}/sensitivedata/policy/summaries`
    )
    return policies.map(normalize)
  }
}
